export enum VideoEmbedSource {
    YOUTUBE = "YouTube",
    VIMEO = "Vimeo",
    WISTIA = "Wistia",
}